import gql from 'graphql-tag'

export default gql`
  extend type Query {
    #    connected: Boolean!
    #    loading: Boolean!
    #    darkMode: Boolean!
    #    currentProjectId: String
    currentAccountId: ID
    currentAccount: Account
  }
  extend type Mutation {
    currentAccountIdSet (account_id: ID!): Boolean
    #    connectedSet (value: Boolean!): Boolean
    #    loadingChange (mod: Int!): Boolean
    #    darkModeSet (enabled: Boolean!): Boolean
    #    currentProjectIdSet (projectId: String): Boolean
  }
`
